<template>
  <div v-if="displaySelector" style="display: block; float: left; width: 100%">
    <h4 v-if="title !== ''" :class="{ pointer: collapsable }" @click="toggleOpen">
      {{ title }}
      <i
        v-if="collapsable"
        :class="{ 'zmdi-chevron-down': !open, 'zmdi-chevron-up': open }"
        class="zmdi pointer"
      />
    </h4>
    <blockquote class="small m-b-10" style="width: 100%">
      <transition name="expand">
        <div v-if="open">
          <div v-if="refListObj.list != null">
            <div v-if="children">
              <ListAnimation>
                <div
                  v-for="(value, id, index) in refListObj.list"
                  :key="idValue(value, id)"
                  :class="type"
                  :data-index="getIndex(id, index)"
                  class="cap-first-letter"
                >
                  <div v-if="children[idValue(value, id)]">
                    <label>
                      <input
                        v-model="binder"
                        :type="type"
                        :name="name"
                        :value="idValue(value, id)"
                      />
                      <i class="input-helper" />
                      <span @click="toggleChildren(idValue(value, id), true)">
                        {{ $t(value.name ? value.name : value) }}
                      </span>
                    </label>
                    <i
                      :class="{
                        'zmdi-chevron-down': !displayChildren[idValue(value, id)],
                        'zmdi-chevron-up': displayChildren[idValue(value, id)],
                      }"
                      class="zmdi pointer"
                      @click="toggleChildren(idValue(value, id))"
                    />
                    <span
                      v-if="value.counted !== undefined && displayCount"
                      class="num-options label circle circle-10 label-basic"
                    >
                      {{ value.counted === null ? 0 : value.counted }}
                    </span>
                    <transition name="expand">
                      <div
                        v-show="displayChildren[idValue(value, id)]"
                        :key="idValue(value, id)"
                        style="overflow: hidden"
                      >
                        <SelectBoxes
                          :children="children[idValue(value, id)].children"
                          :ref-list-obj="children[idValue(value, id)].refObj"
                          :set-title="children[idValue(value, id)].title"
                          :set-type="children[idValue(value, id)].type"
                          :set-name="children[idValue(value, id)].name"
                          :set-approved="children[idValue(value, id)].approved"
                          :display="true"
                          :mutator="children[idValue(value, id)].mutator"
                        />
                      </div>
                    </transition>
                  </div>
                  <label v-else>
                    <input v-model="binder" :type="type" :name="name" :value="idValue(value, id)" />
                    {{ $t(value.name ? value.name : value) }}
                    <i class="input-helper" />
                    <span
                      v-if="value.counted !== undefined"
                      class="num-options label circle circle-10 label-basic"
                    >
                      {{ value.counted === null ? 0 : value.counted }}
                    </span>
                  </label>
                </div>
              </ListAnimation>
            </div>
            <div v-else>
              <ListAnimation>
                <div
                  v-for="(value, id, index) in refListObj.list"
                  :key="idValue(value, id)"
                  :class="type"
                  :data-index="getIndex(id, index)"
                  class="cap-first-letter"
                >
                  <label>
                    <input v-model="binder" :type="type" :name="name" :value="idValue(value, id)" />
                    {{ $t(value.name ? value.name : value) }}
                    <i class="input-helper" />
                    <span
                      v-if="value.counted !== undefined"
                      class="num-options label circle circle-10 label-basic"
                    >
                      {{ value.counted === null ? 0 : value.counted }}
                    </span>
                  </label>
                </div>
              </ListAnimation>
            </div>
          </div>
          <SelectSkeleton v-else />
        </div>
      </transition>
    </blockquote>
  </div>
</template>

<script>
import ListAnimation from '@/components/ListAnimation.vue'
import SelectSkeleton from '@/components/SelectSkeleton.vue'

export default {
  name: 'SelectBoxes',
  components: {
    ListAnimation,
    SelectSkeleton,
  },
  props: {
    refListObj: {
      type: Object,
      required: true,
    },
    setType: {
      type: String,
      required: false,
    },
    displayCount: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    setTitle: {
      type: String,
      required: true,
    },
    setName: {
      type: String,
      required: true,
    },
    setApproved: {
      type: Boolean,
      required: false,
      default: false,
    },
    display: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    collapsable: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayToCompany: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    mutator: {
      type: String,
      required: false,
    },
    children: {
      type: Array,
      required: false,
    },
    startCollapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      type: 'checkbox',
      title: '',
      name: '',
      displayChildren: [],
      checkedChildren: false,
      open: true,
    }
  },
  computed: {
    userIsApproved() {
      return typeof this.user === 'object'
    },
    userIsCompany() {
      return this.account.isCompany
    },
    displaySelector() {
      if (!this.display) {
        return false
      }
      if (this.userIsCompany && !this.displayToCompany) {
        return false
      }
      if (!this.userIsCompany && this.setApproved && !this.userIsApproved) {
        return false
      }
      return true
    },
    /**
     * Works as a two way binder so that we can both use a unspecified vuex store, and use a normal js object
     */
    binder: {
      get() {
        return this.refListObj.selected
      },
      set(value) {
        if (this.mutator) {
          this.$store.commit(this.mutator, value)
        } else {
          // eslint-disable-next-line vue/no-mutating-props -- Baseline eslint ignore please fix if working on this
          this.refListObj.selected = value
        }
      },
    },
  },
  created() {
    this.title = this.setTitle
    this.type = this.setType || 'checkbox'
    this.name = this.setName
    this.open = !this.startCollapsed
  },
  updated() {
    this.expandActiveChildren()
  },
  methods: {
    /**
     * If we have children, then we need to know which child we need to display for each point.
     * @param child
     */
    toggleChildren(child, state = undefined) {
      this.displayChildren[child] = state !== undefined ? state : !this.displayChildren[child]
      this.$forceUpdate() // Not optimal, but the best solution with the current setup
    },
    idValue(value, id) {
      return value && value.id !== undefined ? value.id : id
    },
    getIndex(id, index) {
      if (typeof id === 'number') {
        return id
      }
      return index
    },
    toggleOpen() {
      if (this.collapsable) {
        this.open = !this.open
      }
    },
    // This functions expands folded options if a child is active
    expandActiveChildren() {
      if (this.children && this.refListObj && this.refListObj.list && !this.checkedChildren) {
        // We only want to run this function once when the data is loaded, so we ensure that here
        this.checkedChildren = true

        // We then run over all of our options
        // eslint-disable-next-line guard-for-in -- Baseline eslint ignore please fix if working on this
        for (const id in this.refListObj.list) {
          // Here we extract specific values from the options
          const value = this.refListObj.list[id]
          const childrenSelector = this.idValue(value, id)
          const child = this.children[childrenSelector]

          if (child && child.refObj) {
            // We now run over the childs options
            // eslint-disable-next-line guard-for-in, @typescript-eslint/no-shadow -- Baseline eslint ignore please fix if working on this
            for (const id in child.refObj.list) {
              // Extracting values
              // eslint-disable-next-line @typescript-eslint/no-shadow -- Baseline eslint ignore please fix if working on this
              const value = child.refObj.list[id]
              const { selected } = child.refObj

              // Since sometimes the selected options can be an array or a specific value, we have this condition.
              if (selected && typeof selected === 'object' && selected.length > 0) {
                if (selected.indexOf(this.idValue(value, id)) !== -1) {
                  this.toggleChildren(childrenSelector, true)
                }
              // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
              } else if (this.idValue(value, id) == selected) {
                this.toggleChildren(childrenSelector, true)
              }
            }
          }
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
blockquote::before {
  content: '' !important;
}
.cap-first-letter {
  &:first-letter {
    text-transform: uppercase;
  }
}
.num-options {
  position: absolute;
  right: 0;
  top: 3px;
}

h4 {
  position: relative;
  max-height: 40px;
  i.zmdi {
    position: absolute;
    top: 3px;
    right: -5px;
  }
}

i.zmdi {
  position: absolute;
  top: 3px;
  right: -15px;
}
// This part removes any unwanted parents influence on the css of a child if the differ in type
.radio .checkbox .input-helper {
  &:before {
    top: 0;
    width: 17px;
    height: 17px;
    border-radius: 2px;
  }
  &:after {
    border-radius: 0;
    top: 0;
    left: 2px;
  }
}
</style>
